<template>
  <div id="panelChart9" class="panel panel-default">

    <div class="panel-title top-margin">Additional emails</div>

    <div class="line-separator"></div>

    <SuccessAlert
      :isVisible="isSuccessMessageDisplayed"
      :message="successMessage"
      @hideSuccessAlert="hideSuccessMessage" />

    <div class="row" v-if="emails.length === 0 && !shouldFormForNewEmailBeDisplayed">
      <div class="col-lg-12">
        <div class="alert alert-info alert-dismissible" role="alert">
          No additional emails were found.
        </div>
      </div>
    </div>

    <div v-if="emails.length > 0 || shouldFormForNewEmailBeDisplayed"
      v-bind:class="{'table-fixed-header--md cols-4': emails.length > 6, 'table-responsive': true, 'bottom-margin': true}">

      <table class="table table-striped">
        <thead>
          <tr>
            <th class="text-left column-email">Email address</th>

            <th class="text-left column-actions">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr id="newEmailRow"
            :class="{
              'new-email-form-shrunk': !errors.has('newEmail') && isEmailUnique(),
              'new-email-form-expanded': errors.has('newEmail') || !isEmailUnique(),
              }"
            v-if="shouldFormForNewEmailBeDisplayed">

            <td class="text-left column-email">
              <div class="row margin-0">
                <div class="row margin-0">
                  <input name="newEmail"
                    id="newEmail"
                    type="email"
                    :class="{ 'form-control': true, 'form-control-error': errors.has('newEmail') || !isEmailUnique() }"
                    v-validate="{ required: true, email: true }"
                    v-model="newEmail"
                    required
                    placeholder="e.g., john.doe@yourinstitution.com" />
                </div>

                <div class="row margin-0">
                  <span v-if="errors.has('newEmail')" class="error-feedback">Required</span>
                </div>

                <div class="row margin-0">
                  <span v-if="!isEmailUnique()" class="error-feedback">Email cannot be a duplicate</span>
                </div>
              </div>
            </td>

            <td class="text-left column-actions">
              <div class="row margin-0">
                <div class="col-lg-4 padding-0">
                  <button type="button"
                    class="btn btn-info btn-lg button--add buttons"
                    :disabled="errors.has('newEmail') || !newEmail || !isEmailUnique()"
                    @click="addNewEmail">
                    Add
                  </button>
                </div>

                <div class="col-lg-8 text-center padding-0">
                  <button type="button"
                    class="btn btn-info btn-lg button--discard buttons"
                    @click="hideFormForNewEmail" >
                    Discard
                  </button>
                </div>
              </div>

            </td>
          </tr>

          <tr v-for="(emailObj, index) in emails" :key="index">
            <td class="text-left column-email">{{ emailObj.email }}</td>

            <td class="text-left column-actions">
              <button type="button" class="btn btn-trash"
                @click="showQuestionModalForDeletionOfEmail(emailObj.email)">
                <em class="fa fa-trash fa-2x delete-icon"></em>
              </button>
            </td>
          </tr>
        </tbody>
      </table>

    </div>

    <div class="row top-margin bottom-margin">
      <div class="col-lg-12">
        <button type="button"
          class="btn btn-default btn-lg"
          @click="displayFormForNewEmail" >
          Add additional email
        </button>
      </div>
    </div>

  </div>
</template>

<script>
  import { mapActions, mapMutations } from 'vuex';

  import {
    CLOSE_SUCCESS_ALERT,
    HIDE_QUESTION_MODAL,
    SHOW_QUESTION_MODAL,
    SHOW_SUCCESS_ALERT,
  } from '@/store/mutation-types';

  import { Events } from '@/data/static/events';
  import { Constants } from '@/data/static/constants';

  import SuccessAlert from '@/components/SuccessAlert';

  export default {
    name: 'AccountEmails',
    beforeDestroy() {
      this.hideSuccessMessage();
    },
    components: {
      SuccessAlert,
    },
    data() {
      return {
        errorMessage: null,
        isSuccessMessageDisplayed: false,
        newEmail: null,
        shouldFormForNewEmailBeDisplayed: false,
        successMessage: '',
      };
    },
    methods: {
      ...mapActions('account', [
        'addAccountEmail',
        'deleteAccountEmail',
      ]),
      ...mapMutations('question', {
        hideQuestionModal: HIDE_QUESTION_MODAL,
        showQuestionModal: SHOW_QUESTION_MODAL,
      }),
      ...mapMutations('successAlert', {
        hideSuccessAlert: CLOSE_SUCCESS_ALERT,
        showSuccessAlert: SHOW_SUCCESS_ALERT,
      }),
      async addNewEmail() {
        try {
          this.$emit(Events.ADDITIONAL_EMAILS_ADDING_STARTED);

          await this.addAccountEmail({
            accountId: this.accountId,
            email: this.newEmail,
          });

          this.newEmail = null;
          this.shouldFormForNewEmailBeDisplayed = false;
          this.successMessage = Constants.additionalEmail.successMessageAfterAddition;
          this.isSuccessMessageDisplayed = true;
          this.$emit(Events.ADDITIONAL_EMAILS_ADDING_SUCCEED);
        } catch (error) {
          this.$emit(Events.ADDITIONAL_EMAILS_ADDING_FAILED, error);
        }
      },
      displayFormForNewEmail() {
        this.shouldFormForNewEmailBeDisplayed = true;
      },
      async executeMethodInQuestionModalForDeletionOfEmail(email) {
        try {
          this.$emit(Events.ADDITIONAL_EMAILS_DELETING_STARTED);

          await this.deleteAccountEmail({
            accountId: this.accountId,
            email,
          });

          this.hideQuestionModal();
          this.successMessage = Constants.additionalEmail.successMessageAfterDeletion;
          this.isSuccessMessageDisplayed = true;
          this.$emit(Events.ADDITIONAL_EMAILS_DELETING_SUCCEED);
        } catch (error) {
          this.$emit(Events.ADDITIONAL_EMAILS_DELETING_FAILED, error);
        }
      },
      hideFormForNewEmail() {
        this.shouldFormForNewEmailBeDisplayed = false;
      },
      hideSuccessMessage() {
        this.isSuccessMessageDisplayed = false;
      },
      isEmailUnique() {
        const emailFound = this.emails.find(emailObj => emailObj.email === this.newEmail);
        this.errorMessage = emailFound !== undefined ? 'Email cannot be a duplicate' : null;
        return emailFound === undefined;
      },
      showQuestionModalForDeletionOfEmail(email) {
        this.showQuestionModal({
          title: Constants.additionalEmail.modalTitle,
          question: Constants.additionalEmail.modalQuestion,
          method: async () => {
            await this.executeMethodInQuestionModalForDeletionOfEmail(email);
          },
          yesButtonText: Constants.additionalEmail.modalYesButtonText,
          hideCancelButton: false,
        });
      },
    },
    props: ['accountId', 'emails'],
  };
</script>

<style lang="scss" scoped>
  .panel-title {
    font-size: 20px;
    margin-bottom: 5px;
  }
  .btn-trash {
    border: 1px solid #DCE0E5;
    background: white;
  }
  .delete-icon {
    color: #f05050;
    margin-top: -3px;
  }
  .top-margin {
    margin-top: 2%;
  }
  .radio-item label {
    color: #666;	    color: #666;
    font-weight: normal;
    padding-left: 25px;
    padding-top: 5px;
    cursor: pointer;
  }
  .radio-item {
    height: 25px;
  }
  .radio-item label:before {
    content: " ";
    display: inline-block;
    position: absolute;
    top: 0;
    left: 0px;
    margin: 0 5px 0 0;
    width: 20px;
    height: 20px;
    border-radius: 11px;
    background-color: transparent;
  }
  .radio-item-unselected label:before {
    border: 2px solid #d3d3d3;
  }
  .radio-item label:after {
    border-radius: 5px;
    width: 10px;
    height: 10px;
    position: absolute;
    top: 5px;
    left: 5px;
    margin: auto;
    content: "";
    display: block;
    background-color: #127285;
  }
  .radio-item.radio-item-unselected label:after {
    display: none;
  }
  table {
    border-collapse: collapse;
  }
  th {
    padding: 14px 8px;
    color: #888;
    border-bottom-width: 1px;
    vertical-align: bottom;
    border-bottom: 1px solid #eee;
    border-top: 0;
    line-height: 1.52857143;
    font-weight: normal;
  }
  td {
    padding: 8px;
    line-height: 1.52857143;
    vertical-align: top;
    border-top: 1px solid #eee;
    height: 60px;
  }
  .table-striped>tbody>tr:nth-of-type(odd) {
    background-color: #fafbfc;
  }
  .panel-title {
    font-size: 20px;
  }
  .panel-default {
    padding: 30px 40px;
  }
  .line-separator {
    padding: 8px;
    line-height: 1.52857143;
    vertical-align: top;
    border-top: 1px solid #eee;
  }
  tbody tr td:last-child {
    padding-top: 10px;
  }
  .column-email {
    width: calc(100% - 180px);
    vertical-align: top;
    padding-top: 10px;
  }
  .column-email input {
    height: 38px;
    margin-top: 2px;
  }
  .column-actions {
    width: 180px;
    vertical-align: top;
  }
  .button-approve {
    background-color: #127285;
  }
  .buttons {
    display: inline-block;
    margin: 0 5px;
    transition: all .2s ease-in-out;
  }
  .button--add {
    background-color: white;
    border-color: #127285;
    color: #127285;
    &:hover, &:focus {
      background-color: #127285;
      color: white;
      box-shadow: 0 0 4px #00788d;
    }
  }
  .button--discard {
    background-color: white;
    border-color: #DCE0E5;
    color: #515253;
    &:hover, &:focus {
      background-color: #DCE0E5;
      box-shadow: 0 0 4px #DCE0E5;
    }
  }
  .new-email-form-shrunk {
    height: 65px;
  }
  .new-email-form-expanded {
    height: 80px;
  }
</style>



// WEBPACK FOOTER //
// AccountEmails.vue?c514a726